import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table, Button, Input, Select } from 'antd';
import { Link } from 'react-router-dom';

const { Option } = Select;

const OrganizationList = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [size, setSize] = useState(16);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchField, setSearchField] = useState('id');
  const [sortField, setSortField] = useState('id');
  const [sortOrder, setSortOrder] = useState('asc');
  const [orgType, setOrgType] = useState('all'); // Added state for organization type
  const [orgTypes, setOrgTypes] = useState([]); // State to store organization types

  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/organization/pagination';
  const SEARCH_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/organization/search';
  const ORGTYPE_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/organization/orgType/all';
  const FILTER_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/organization/filter-org-type';

  const fetchOrganizations = async () => {
    try {
      setLoading(true);
      const params = { page, size, sortField, sortOrder };

      if (orgType && orgType !== 'all') {
        params.orgType = orgType;
      }

      const url = orgType && orgType !== 'all' ? FILTER_API_URL : API_URL;
      const response = await axios.get(url, { params });
      setOrganizations(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, [page, size, sortField, sortOrder, orgType]);

  const searchOrganizations = async () => {
    try {
      const response = await axios.get(SEARCH_API_URL, {
        params: { keyword: searchKeyword, searchField },
      });
      setOrganizations(response.data);
      setTotalPages(1);
    } catch (error) {
      setError(error);
    }
  };

  const fetchOrgTypes = async () => {
    try {
      const response = await axios.get(ORGTYPE_API_URL);
      const allOrgTypes = [{ id: 'all', name: 'All' }, ...response.data];
      setOrgTypes(allOrgTypes);
    } catch (error) {
      console.error('Error fetching organization types:', error);
      setError(error);
    }
  };

  useEffect(() => {
    fetchOrgTypes();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns = [
    { title: 'क्र.सं', dataIndex: 'id', key: 'id' },
    { title: 'सँस्थाको नाम', dataIndex: 'name', key: 'name' },
    { title: 'सँस्था प्रमुख', dataIndex: 'orgOwner', key: 'orgOwner' },
    { title: 'फोन', dataIndex: 'phone', key: 'phone' },
    { title: 'सँस्थाको प्रकार', dataIndex: 'orgType', key: 'orgType' },
    {
      title: 'विवरण',
      key: 'details',
      render: (text, record) => (
        <Link to={`/organization/${record.id}/details`} className="text-blue-500 hover:underline">
          बिस्तृत विवरण
        </Link>
      ),
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0
      ? 'even-row'
      : 'odd-row';
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-1 pt-20 px-10">
        <Sidebar />
        <div className="p-4 md:ml-56 w-full">
          <h1 className="text-2xl font-semibold mb-4 pt-10">संस्थाको सुची</h1>
          {/* Search Section */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
            <div className="flex flex-wrap gap-2">
              <Select
                value={searchField}
                onChange={(value) => setSearchField(value)}
                className="w-28"
                size="large"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="orgOwner">सँस्था प्रमुख</Option>
                <Option value="phone">फोन</Option>
                <Option value="email">इमेल</Option>
              </Select>
              <Input
                placeholder="खोज..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="w-48"
                size="large"
              />
              <Button type="primary" size="large" onClick={searchOrganizations}>
                खोज
              </Button>
            </div>
              {/* Sorting Section */}
              <div className="flex items-center gap-2">
              <label className="mr-2">Sort By:</label>
              <Select
                onChange={(value) => setSortField(value)}
                value={sortField}
                className="w-32"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="orgOwner">सँस्था प्रमुख</Option>
                <Option value="phone">फोन</Option>
                <Option value="email">इमेल</Option>
              </Select>
              <label className="ml-4 mr-2">Order:</label>
              <Select
                onChange={(value) => setSortOrder(value)}
                value={sortOrder}
                className="w-32"
              >
                <Option value="asc">माथिबाट</Option>
                <Option value="desc">तलबाट</Option>
              </Select>
            </div>
            {/* Organization Type */}
            <div className="flex gap-2 items-center">
              <span>संस्थाको प्रकार:</span>
              <Select
                value={orgType}
                onChange={(value) => setOrgType(value)}
                className="w-32"
              >
                {orgTypes.map((ot) => (
                  <Option key={ot.id} value={ot.id}>{ot.nameNep}</Option>
                ))}
              </Select>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <Table
              dataSource={organizations}
              columns={columns}
              pagination={false}
              rowClassName={rowClassName}
              bordered
              className="custom-table w-full"
            />
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-end mt-4 gap-2">
            <Button onClick={() => setPage(page - 1)} disabled={page === 0}>
              Previous
            </Button>
            <Button onClick={() => setPage(page + 1)} disabled={page >= totalPages - 1}>
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationList;
